import { useMutation } from 'react-query';
import { useState } from 'react';
import { getWinnerItemsCountService } from 'pages/Raffle/services/raffle';

type WinnerItemsCount = {
  isQueryingWinnerItemsCount: boolean;
  hasErrorGettingWinnerItemsCount: boolean;
  handleGetWinnerItemsCount: () => void;
  winnerItemsCount: number;
};

function useGetWinnerItemsCount(): WinnerItemsCount {
  const [winnersCount, setWinnersCount] = useState<number>(0);
  const {
    isLoading: isQueryingWinnerItemsCount,
    isError: hasErrorGettingWinnerItemsCount,
    mutateAsync: getWinnerItemsCount,
  } = useMutation('getWinnerItemsCount', getWinnerItemsCountService);
  async function handleGetWinnerItemsCount() {
    try {
      const response = await getWinnerItemsCount();
      if (response?.data.success) {
        setWinnersCount(response.data.result.count);
      }
    } catch (error) {
      return null;
    }
    return null;
  }

  return {
    isQueryingWinnerItemsCount,
    hasErrorGettingWinnerItemsCount,
    handleGetWinnerItemsCount,
    winnerItemsCount: winnersCount,
  };
}
export default useGetWinnerItemsCount;
